unit DieselDepotPricesSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, XData.Web.Client, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, System.DateUtils;

type
  TfrmDepotPriceSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    btnSaveDepotPrice: TButton;
    WebButton2: TButton;
    WebDBDateTimePicker1: TDBDateTimePicker;
    wcDepotPriceList: TXDataWebClient;
    wdsDepotPriceList: TXDataWebDataSet;
    wdsDepotPriceListAUTONO: TIntegerField;
    wdsDepotPriceListDEPOTCODE: TIntegerField;
    wdsDepotPriceListFROMDATE: TDateField;
    wdsDepotPriceListTODATE: TDateField;
    wdsDepotPriceListCOSTPRICE: TFloatField;
    wdsDepotPriceListSTDPRICE: TFloatField;
    wdsDepotPriceListDEDSUBPRICE: TFloatField;
    wdsDepotPriceListSPECIALPRICE: TFloatField;
    wdsDepotPriceListPRICELOADBY: TStringField;
    wdsDepotPriceListPRICECONFIRMDATE: TDateField;
    wdsDepotPriceListPRICECONFIRMBY: TStringField;
    wdsDepotPriceListPRICECONFIRMED: TBooleanField;
    wdsDepotPriceListfueltype: TIntegerField;
    wdsDepotPriceListfueltypename: TStringField;
    dsDepotPriceList: TDataSource;
    wdsDepotPriceListPRICELOADDATE: TStringField;
    edtFuelTypeName: TDBEdit;
    WebButton3: TButton;
    WebLabel6: TLabel;
    templabel: TLabel;
    procedure btnSaveDepotPriceClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
  private
    { Private declarations }


    procedure LoadDepotPriceList;
  public
    { Public declarations }
    iState, iFuelType : Integer;
    iDepotCodeSetup, iAutoNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmDepotPriceSetup: TfrmDepotPriceSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection ,  share.common, Search.FuelType;

procedure TfrmDepotPriceSetup.LoadDepotPriceList;
procedure OnError(Error: TXDataClientError);
    begin
      LoadDepotPriceList;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadDepotPriceList;
        end
      else
        begin

          wdsDepotPriceList.Close;
          wdsDepotPriceList.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsDepotPriceList.Open;

          wdsDepotPriceList.Edit;
        end;
    end;

begin
  wcDepotPriceList.RawInvoke('IstfmsdieselService.Get_DepotPriceList_View',[0,0,iAutoNo],@OnResultNumbers,@OnError);
end;

procedure TfrmDepotPriceSetup.btnSaveDepotPriceClick(Sender: TObject);
var
  dt: TDateTime;
  ISO8601Date: string;


  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      btnSaveDepotPrice.Enabled := true;
      ShowMessage('Depot Price Successfully saved');

      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      btnSaveDepotPrice.Enabled := true;
      ShowMessage(Error.ErrorMessage);
    end;
begin
  btnSaveDepotPrice.Enabled := false;
  wdsDepotPriceList.FieldByName('DEPOTCODE').AsInteger := iDepotCodeSetup;
  wdsDepotPriceList.FieldByName('PRICELOADDATE').AsString := FormatDateTime('yyyy-mm-dd', Date);
  wdsDepotPriceList.FieldByName('PRICECONFIRMED').AsBoolean := false;
  //wdsDepotPriceList.FieldByName('PriceLoadBy').AsString := String(User.Code);
  case iState of
    1:  Begin
          console.log(GetJsonFromDataSet(wdsDepotPriceList));
          wcDepotPriceList.RawInvoke('IstfmsdieselService.Put_DepotPriceList_Insert',[GetJsonFromDataSet(wdsDepotPriceList)],@OnSuccess,@OnError);
        End;
    2:  Begin
          wcDepotPriceList.RawInvoke('IstfmsdieselService.Put_DepotPriceList_Edit',[GetJsonFromDataSet(wdsDepotPriceList)],@OnSuccess,@OnError);
        End;
  end;


end;

procedure TfrmDepotPriceSetup.WebButton2Click(Sender: TObject);
begin
  wdsDepotPriceList.Close;
  Close;
end;

procedure TfrmDepotPriceSetup.WebButton3Click(Sender: TObject);
  var
    newform : TfrmFuelTypeSearch;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if iFuelTypeSearch > -1 then
              begin
                edtFuelTypeName.Text := sFuelTypeNameSearch;

                //wdsSystemLedgerAccounts.FieldByName('systemtype').AsInteger
                wdsDepotPriceList.FieldByName('fueltype').AsInteger := iFuelTypeSearch;
                templabel.Caption := IntToStr(iFuelTypeSearch);
              end
            else
              begin
                edtFuelTypeName.Text := '';
                //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
              end;
          end;
      end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;//(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);

end;

procedure TfrmDepotPriceSetup.WebFormShow(Sender: TObject);
begin


  case iState of
    1 : Begin
          wdsDepotPriceList.Open;
          wdsDepotPriceList.Insert;
        End;

    2 : Begin
          LoadDepotPriceList;
        End;
  end;



end;



procedure TfrmDepotPriceSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  templabel := TLabel.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnSaveDepotPrice := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  edtFuelTypeName := TDBEdit.Create(Self);
  WebButton3 := TButton.Create(Self);
  wcDepotPriceList := TXDataWebClient.Create(Self);
  wdsDepotPriceList := TXDataWebDataSet.Create(Self);
  wdsDepotPriceListAUTONO := TIntegerField.Create(Self);
  wdsDepotPriceListDEPOTCODE := TIntegerField.Create(Self);
  wdsDepotPriceListFROMDATE := TDateField.Create(Self);
  wdsDepotPriceListTODATE := TDateField.Create(Self);
  wdsDepotPriceListCOSTPRICE := TFloatField.Create(Self);
  wdsDepotPriceListSTDPRICE := TFloatField.Create(Self);
  wdsDepotPriceListDEDSUBPRICE := TFloatField.Create(Self);
  wdsDepotPriceListSPECIALPRICE := TFloatField.Create(Self);
  wdsDepotPriceListPRICELOADBY := TStringField.Create(Self);
  wdsDepotPriceListPRICECONFIRMDATE := TDateField.Create(Self);
  wdsDepotPriceListPRICECONFIRMBY := TStringField.Create(Self);
  wdsDepotPriceListPRICECONFIRMED := TBooleanField.Create(Self);
  wdsDepotPriceListfueltype := TIntegerField.Create(Self);
  wdsDepotPriceListfueltypename := TStringField.Create(Self);
  wdsDepotPriceListPRICELOADDATE := TStringField.Create(Self);
  dsDepotPriceList := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  templabel.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnSaveDepotPrice.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  edtFuelTypeName.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  wcDepotPriceList.BeforeLoadDFMValues;
  wdsDepotPriceList.BeforeLoadDFMValues;
  wdsDepotPriceListAUTONO.BeforeLoadDFMValues;
  wdsDepotPriceListDEPOTCODE.BeforeLoadDFMValues;
  wdsDepotPriceListFROMDATE.BeforeLoadDFMValues;
  wdsDepotPriceListTODATE.BeforeLoadDFMValues;
  wdsDepotPriceListCOSTPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListSTDPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListDEDSUBPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListSPECIALPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListPRICELOADBY.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMDATE.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMBY.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMED.BeforeLoadDFMValues;
  wdsDepotPriceListfueltype.BeforeLoadDFMValues;
  wdsDepotPriceListfueltypename.BeforeLoadDFMValues;
  wdsDepotPriceListPRICELOADDATE.BeforeLoadDFMValues;
  dsDepotPriceList.BeforeLoadDFMValues;
  try
    Name := 'frmDepotPriceSetup';
    Width := 668;
    Height := 348;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 668;
    WebPanel1.Height := 348;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 26;
    WebLabel1.Top := 104;
    WebLabel1.Width := 123;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Price Active Date From:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 26;
    WebLabel2.Top := 184;
    WebLabel2.Width := 56;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Cost Price:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 176;
    WebLabel3.Top := 184;
    WebLabel3.Width := 53;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'STD Price:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 336;
    WebLabel4.Top := 184;
    WebLabel4.Width := 79;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Ded. Sub Price:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 496;
    WebLabel5.Top := 181;
    WebLabel5.Width := 69;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Special Price:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel1);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 288;
    WebLabel6.Top := 104;
    WebLabel6.Width := 53;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Fuel Type:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    templabel.SetParentComponent(WebPanel1);
    templabel.Name := 'templabel';
    templabel.Left := 456;
    templabel.Top := 88;
    templabel.Width := 53;
    templabel.Height := 15;
    templabel.Caption := 'templabel';
    templabel.HeightPercent := 100.000000000000000000;
    templabel.WidthPercent := 100.000000000000000000;
    WebDBEdit3.SetParentComponent(WebPanel1);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 26;
    WebDBEdit3.Top := 205;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 7;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'COSTPRICE';
    WebDBEdit3.DataSource := dsDepotPriceList;
    WebDBEdit4.SetParentComponent(WebPanel1);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 176;
    WebDBEdit4.Top := 205;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 8;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'STDPRICE';
    WebDBEdit4.DataSource := dsDepotPriceList;
    WebDBEdit5.SetParentComponent(WebPanel1);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 336;
    WebDBEdit5.Top := 205;
    WebDBEdit5.Width := 121;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 9;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'DEDSUBPRICE';
    WebDBEdit5.DataSource := dsDepotPriceList;
    WebDBEdit6.SetParentComponent(WebPanel1);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 496;
    WebDBEdit6.Top := 205;
    WebDBEdit6.Width := 121;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 10;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit6';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'SPECIALPRICE';
    WebDBEdit6.DataSource := dsDepotPriceList;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 668;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Depot Price Setup';
    WebPanel2.ChildOrder := 11;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 4;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 288;
    WebPanel3.Width := 668;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 12;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 5;
    btnSaveDepotPrice.SetParentComponent(WebPanel3);
    btnSaveDepotPrice.Name := 'btnSaveDepotPrice';
    btnSaveDepotPrice.Left := 10;
    btnSaveDepotPrice.Top := 16;
    btnSaveDepotPrice.Width := 96;
    btnSaveDepotPrice.Height := 25;
    btnSaveDepotPrice.Caption := 'Save';
    btnSaveDepotPrice.Color := clGreenyellow;
    btnSaveDepotPrice.HeightPercent := 100.000000000000000000;
    btnSaveDepotPrice.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveDepotPrice, Self, 'OnClick', 'btnSaveDepotPriceClick');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 120;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBDateTimePicker1.SetParentComponent(WebPanel1);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 26;
    WebDBDateTimePicker1.Top := 125;
    WebDBDateTimePicker1.Width := 170;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 11;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45890.460412210650000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker1.DataField := 'FROMDATE';
    WebDBDateTimePicker1.DataSource := dsDepotPriceList;
    edtFuelTypeName.SetParentComponent(WebPanel1);
    edtFuelTypeName.Name := 'edtFuelTypeName';
    edtFuelTypeName.Left := 280;
    edtFuelTypeName.Top := 125;
    edtFuelTypeName.Width := 177;
    edtFuelTypeName.Height := 22;
    edtFuelTypeName.ChildOrder := 12;
    edtFuelTypeName.HeightPercent := 100.000000000000000000;
    edtFuelTypeName.ReadOnly := True;
    edtFuelTypeName.Text := 'edtFuelTypeName';
    edtFuelTypeName.WidthPercent := 100.000000000000000000;
    edtFuelTypeName.DataField := 'fueltypename';
    edtFuelTypeName.DataSource := dsDepotPriceList;
    WebButton3.SetParentComponent(WebPanel1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 463;
    WebButton3.Top := 124;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 13;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    wcDepotPriceList.SetParentComponent(Self);
    wcDepotPriceList.Name := 'wcDepotPriceList';
    wcDepotPriceList.Connection := dmData.dbConnect;
    wcDepotPriceList.Left := 33;
    wcDepotPriceList.Top := 12;
    wdsDepotPriceList.SetParentComponent(Self);
    wdsDepotPriceList.Name := 'wdsDepotPriceList';
    wdsDepotPriceList.Connection := dmData.dbConnect;
    wdsDepotPriceList.Left := 89;
    wdsDepotPriceList.Top := 12;
    wdsDepotPriceListAUTONO.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListAUTONO.Name := 'wdsDepotPriceListAUTONO';
    wdsDepotPriceListAUTONO.FieldName := 'AUTONO';
    wdsDepotPriceListDEPOTCODE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListDEPOTCODE.Name := 'wdsDepotPriceListDEPOTCODE';
    wdsDepotPriceListDEPOTCODE.FieldName := 'DEPOTCODE';
    wdsDepotPriceListFROMDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListFROMDATE.Name := 'wdsDepotPriceListFROMDATE';
    wdsDepotPriceListFROMDATE.FieldName := 'FROMDATE';
    wdsDepotPriceListTODATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListTODATE.Name := 'wdsDepotPriceListTODATE';
    wdsDepotPriceListTODATE.FieldName := 'TODATE';
    wdsDepotPriceListCOSTPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListCOSTPRICE.Name := 'wdsDepotPriceListCOSTPRICE';
    wdsDepotPriceListCOSTPRICE.FieldName := 'COSTPRICE';
    wdsDepotPriceListSTDPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListSTDPRICE.Name := 'wdsDepotPriceListSTDPRICE';
    wdsDepotPriceListSTDPRICE.FieldName := 'STDPRICE';
    wdsDepotPriceListDEDSUBPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListDEDSUBPRICE.Name := 'wdsDepotPriceListDEDSUBPRICE';
    wdsDepotPriceListDEDSUBPRICE.FieldName := 'DEDSUBPRICE';
    wdsDepotPriceListSPECIALPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListSPECIALPRICE.Name := 'wdsDepotPriceListSPECIALPRICE';
    wdsDepotPriceListSPECIALPRICE.FieldName := 'SPECIALPRICE';
    wdsDepotPriceListPRICELOADBY.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICELOADBY.Name := 'wdsDepotPriceListPRICELOADBY';
    wdsDepotPriceListPRICELOADBY.FieldName := 'PRICELOADBY';
    wdsDepotPriceListPRICECONFIRMDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMDATE.Name := 'wdsDepotPriceListPRICECONFIRMDATE';
    wdsDepotPriceListPRICECONFIRMDATE.FieldName := 'PRICECONFIRMDATE';
    wdsDepotPriceListPRICECONFIRMBY.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMBY.Name := 'wdsDepotPriceListPRICECONFIRMBY';
    wdsDepotPriceListPRICECONFIRMBY.FieldName := 'PRICECONFIRMBY';
    wdsDepotPriceListPRICECONFIRMED.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMED.Name := 'wdsDepotPriceListPRICECONFIRMED';
    wdsDepotPriceListPRICECONFIRMED.FieldName := 'PRICECONFIRMED';
    wdsDepotPriceListfueltype.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListfueltype.Name := 'wdsDepotPriceListfueltype';
    wdsDepotPriceListfueltype.FieldName := 'fueltype';
    wdsDepotPriceListfueltypename.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListfueltypename.Name := 'wdsDepotPriceListfueltypename';
    wdsDepotPriceListfueltypename.FieldName := 'fueltypename';
    wdsDepotPriceListPRICELOADDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICELOADDATE.Name := 'wdsDepotPriceListPRICELOADDATE';
    wdsDepotPriceListPRICELOADDATE.FieldName := 'PRICELOADDATE';
    dsDepotPriceList.SetParentComponent(Self);
    dsDepotPriceList.Name := 'dsDepotPriceList';
    dsDepotPriceList.AutoEdit := False;
    dsDepotPriceList.DataSet := wdsDepotPriceList;
    dsDepotPriceList.Left := 145;
    dsDepotPriceList.Top := 12;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    templabel.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnSaveDepotPrice.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    edtFuelTypeName.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    wcDepotPriceList.AfterLoadDFMValues;
    wdsDepotPriceList.AfterLoadDFMValues;
    wdsDepotPriceListAUTONO.AfterLoadDFMValues;
    wdsDepotPriceListDEPOTCODE.AfterLoadDFMValues;
    wdsDepotPriceListFROMDATE.AfterLoadDFMValues;
    wdsDepotPriceListTODATE.AfterLoadDFMValues;
    wdsDepotPriceListCOSTPRICE.AfterLoadDFMValues;
    wdsDepotPriceListSTDPRICE.AfterLoadDFMValues;
    wdsDepotPriceListDEDSUBPRICE.AfterLoadDFMValues;
    wdsDepotPriceListSPECIALPRICE.AfterLoadDFMValues;
    wdsDepotPriceListPRICELOADBY.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMDATE.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMBY.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMED.AfterLoadDFMValues;
    wdsDepotPriceListfueltype.AfterLoadDFMValues;
    wdsDepotPriceListfueltypename.AfterLoadDFMValues;
    wdsDepotPriceListPRICELOADDATE.AfterLoadDFMValues;
    dsDepotPriceList.AfterLoadDFMValues;
  end;
end;

end.